import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtZAR(n) {
  if (n == null || isNaN(n)) return "R 0";
  return "R " + Number(n).toLocaleString("en-ZA", { maximumFractionDigits: 0 });
}

export const PROJECT_TYPE_LABELS = {
  renovation: "Renovation",
  new_build: "New Build",
  addition: "Addition",
  interior_upgrade: "Interior Upgrade",
  commercial_fitout: "Commercial Fitout",
};
export const BUDGET_LABELS = {
  under_50k: "Under R50,000",
  "50k_150k": "R50,000 – R150,000",
  "150k_500k": "R150,000 – R500,000",
  "500k_plus": "R500,000+",
};
export const TIMELINE_LABELS = {
  asap: "ASAP",
  "1_month": "1 Month",
  "3_months": "3 Months",
  "6_months": "6 Months",
};
export const STATUS_LABELS = {
  awaiting_admin_review: "Awaiting review",
  awaiting_customer_info: "More info needed",
  assigned: "Assigned",
  rejected: "Declined",
  submitted: "Submitted",
  estimate_ready: "Estimate Ready",
  quote_requested: "Quote Requested",
  quote_ready: "Quote Ready",
  approved: "Approved",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};
export function statusPillClass(status) {
  const map = {
    awaiting_admin_review: "pill-review",
    awaiting_customer_info: "pill-info",
    assigned: "pill-assigned",
    rejected: "pill-rejected",
    submitted: "pill-submitted",
    estimate_ready: "pill-estimate",
    quote_requested: "pill-quote",
    quote_ready: "pill-quote",
    approved: "pill-approved",
    in_progress: "pill-progress",
    completed: "pill-completed",
  };
  return "pill " + (map[status] || "pill-default");
}
export const REJECTION_CATEGORY_LABELS = {
  out_of_service_area: "Out of service area",
  insufficient_information: "Insufficient information",
  outside_our_scope: "Outside our scope",
  pricing_mismatch: "Pricing mismatch",
  duplicate_request: "Duplicate request",
  other: "Other",
};
// Visual timeline shown on a project detail page (customer-facing).
export const STATUS_TIMELINE = [
  { key: "awaiting_admin_review", label: "Submitted" },
  { key: "assigned", label: "Under review" },
  { key: "quote_ready", label: "Quote sent" },
  { key: "approved", label: "Approved" },
  { key: "in_progress", label: "In progress" },
  { key: "completed", label: "Handover" },
];
export function timelineIndexFor(status) {
  // Map any project status to a step in the customer-facing timeline.
  const map = {
    awaiting_admin_review: 0,
    awaiting_customer_info: 0,
    rejected: 0,
    submitted: 0,
    estimate_ready: 0,
    assigned: 1,
    quote_requested: 1,
    quote_ready: 2,
    approved: 3,
    in_progress: 4,
    completed: 5,
  };
  return map[status] ?? 0;
}
export const ROLE_LABELS = {
  customer: "Customer",
  surveyor: "Surveyor",
  estimator: "Estimator",
  project_manager: "Project Manager",
  admin: "Administrator",
};
